import { Avatar, Box } from "@chakra-ui/react";
import Carousel from "./coursel";
import tinycolor from "tinycolor2";
import ReactMarkdown from 'react-markdown';

export const DataShow = ({ transformedData, botDetails }) => {
  const isColorDark = (color) => {
    const colorObj = tinycolor(color);
    return colorObj.isDark();
  };
  // console.log(transformedData,"=============> data show")
  const userLogo =
    "https://e7.pngegg.com/pngimages/178/595/png-clipart-user-profile-computer-icons-login-user-avatars-monochrome-black.png";
  const companyLogo = botDetails.companyLogo || userLogo;
  return (
    <>
      {transformedData.length > 0
        ? transformedData.map((message, index) => {
            if (Array.isArray(message)) {
              return (
                <Carousel
                  key={index}
                  items={message}
                  user={message[0].user}
                  botDetails={botDetails}
                />
              );
            } else{
              console.log(message.text)
             const text = 
              typeof message?.text === 'string'?
              <ReactMarkdown  >{message.text.replace(/\\n/g, '\n')}</ReactMarkdown> // Append your suffix
                : message?.text;
                 
        
              return (
                <Box
                  mb={"12px"}
                  width={"fit-content"}
                  float={"right"}
                  alignSelf={message.user ? "flex-end" : ""}
                  key={index}
                >
                  <Box
                    display={"flex"}
                    flexDir={message.user ? "row" : "row-reverse"}
                    justifyContent={"flex-end"}
                    gap={"10px"}
                    key={index}
                    width={"100%"}
                  
                  >
                    <Box
                      fontSize={"14px"}
                      bg={"#F3F4F6"}
                      fontWeight={"400"}
                      // boxShadow=
                      maxWidth={"300px"}
                      p={"8px"}
                       maxWidth={"300px"}
                      borderRadius={"6px"}
                      style={{
                        boxShadow: "rgba(28, 28, 28, 0.2) 0px 5px 12px -3px",
                        whiteSpace: "pre-wrap",
                        wordBreak:"break-word",
                        color:
                          message.user != false
                            ? isColorDark(botDetails?.accentColor)
                              ? "white"
                              : "black"
                            : "black",
                        background:
                          message.user != false ? botDetails.accentColor : "",
                      }}
                    >
                      {text}
                    </Box>

                    {message.user == false && (
                      <Avatar
                        src={message.user ? userLogo : companyLogo}
                        name="Company"
                        size="sm"
                      />
                    )}
                  </Box>
                  <p
                    className="timestamp"
                    style={{
                      textAlign: message.user ? "left" : "right",
                    }}
                  >
                    {message.time}
                  </p>
                </Box>
              );
            }
          })
        : null}
    </>
  );
};
